<template>
 <v-layout row wrap style="text-align:center;">
   <v-flex>
    <v-btn @click="onLink('twitter')" icon color="primary" dark>
      <v-icon>fab fa-twitter</v-icon>
    </v-btn>
   </v-flex>
   <v-flex>
    <v-btn @click="onLink('facebook')" icon color="primary" dark>
      <v-icon>fab fa-facebook-f</v-icon>
    </v-btn>
   </v-flex>
   <v-flex>
    <v-btn @click="onLink('hatena')" icon color="primary" dark>
      <img src="@/assets/img/hateb.png" style="width:22px"/>
    </v-btn>
   </v-flex>
   <!-- <v-flex>
    <v-btn @click="onLink('pocket')" icon color="primary" dark>
      <v-icon>fab fa-get-pocket</v-icon>
    </v-btn>
   </v-flex> -->
   <v-flex>
    <v-btn @click="onLink('line')" icon color="primary" dark>
      <v-icon>fab fa-line</v-icon>
    </v-btn>
   </v-flex>
 </v-layout>
</template>

<script>
export default {
  name: 'SnsButtons',
  data () {
    return {
      path: '',
      url: '',
      domain: 'https://karaiine.jp',
    }
  },
  computed: {
  },
  mounted () {
    this.path = this.$route.path
    this.url = this.domain + this.path

    let paths = this.path.split('/')
    if (paths[1]) {
      if (paths[1] === 'review' || paths[1] === 'food') {
        this.url = this.domain + '/share' + this.path
      }
    }
    // console.log(this.url)
  },
  methods: {
    onLink (name) {
      let title = document.title
      let url = ''
      if (name === 'twitter') {
        url = `https://twitter.com/share?url=${this.url}&hashtags=カライイネ&text=${title}`
      } else if (name === 'hatena') {
        url = `http://b.hatena.ne.jp/add?mode=confirm&url=${this.url}&title=${title}`
      } else if (name === 'pocket') {
        url = `http://getpocket.com/edit?url=${this.url}&title=${title}`
      } else if (name === 'line') {
        url = `https://social-plugins.line.me/lineit/share?url=${this.url}&text=${title}`
      } else if (name === 'facebook') {
        url = `https://www.facebook.com/share.php?u=${this.url}`
      }
      window.open(url, '_blank')
    }
  },
  components: {
  }
}
</script>
<style scoped>
a {
  text-decoration: none;
}
</style>
